import { Dropdown, Menu } from 'antd'
import { faFileExport } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import { SUPPORTED_FORMATS } from '../../Buttons/ExportButton'
import IconButton from '../../Buttons/IconButton'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

export const TIVOLI_EXPORT = 'Tivoli'

const DefaultExport = ({ useCustomExport, onExport }) => {
  const t = useSelector(selectTranslate)

  return (
    <Dropdown
      overlay={
        <Menu onClick={e => onExport(e.item.props.data)}>
          {SUPPORTED_FORMATS.map((f, index) => {
            return <Menu.Item key={index} data={f.value}>{f.label}</Menu.Item>
          })}
          {useCustomExport && (
            <Menu.Item key='custom' data={TIVOLI_EXPORT}>{t(TIVOLI_EXPORT)}</Menu.Item>
          )}
        </Menu>
      }
      trigger={['click']}
    >
      <IconButton icon={faFileExport} />
    </Dropdown>
  )
}

export default DefaultExport
